<script>
import SettingsSection from 'dashboard/components/SettingsSection.vue';
import ChatImportDialog from './ChatImportDialog.vue';
import { useAlert } from 'dashboard/composables';
import { INBOXES_EVENTS } from '../../../../../helper/AnalyticsHelper/events';

export default {
  components: {
    SettingsSection,
    ChatImportDialog,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    openChatImportDialog() {
      this.$refs.chatImportDialogRef?.dialogRef?.open();
    },
    async onImport(file) {
      try {
        if (!file) return;
        await this.$store.dispatch('inboxes/importChats', {
          inboxId: this.inbox.id,
          file: file,
        });
        this.$refs.chatImportDialogRef?.dialogRef?.close();
        useAlert(this.$t('INBOX_MGMT.IMPORT_CHAT_HISTORY.SUCCESS_MESSAGE'));
        this.$track(INBOXES_EVENTS.IMPORT_SUCCESS);
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.IMPORT_CHAT_HISTORY.ERROR_MESSAGE')
        );
        this.$track(INBOXES_EVENTS.IMPORT_FAILURE);
      }
    },
  },
};
</script>

<template>
  <div class="my-2 mx-8">
    <SettingsSection
      :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.IMPORT_CHAT_HISTORY_SUBHEADER')"
      :title="$t('INBOX_MGMT.SETTINGS_POPUP.IMPORT_CHAT_HISTORY_TITLE')"
    >
      <woot-button
        class="clear"
        color-scheme="info"
        icon="upload"
        @click="openChatImportDialog"
      >
        {{ $t('INBOX_MGMT.IMPORT_CHAT_HISTORY.BUTTON_LABEL') }}
      </woot-button>
    </SettingsSection>
    <ChatImportDialog ref="chatImportDialogRef" @import="onImport" />
  </div>
</template>

<style lang="scss" scoped>
.button--disconnect {
  @apply ml-2;
}
</style>
